
'use client';
import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import SeoHeading from '../seo/SeoHeading';
import { HomeSeoSlots, getHomeSlot } from '../../../src/lib/seo/home-headings';

type Props = {
  headings: HomeSeoSlots;
};

const FAQSection: React.FC<Props> = ({ headings }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqData = [
    {
      question: getHomeSlot(headings, 'faqQuestion1').text,
      answer:
        'رزرو به صورت ساده و راحت شاید به جرات بتوان گفت مهمترین عامل در لذت از سفر است. زمانی که تیم ایرانیجا هتل آنلاین در زمینه رزرو هتل در کنار شما باشند، این مسئله به سادگی میسر می‌شود. پشتیبانی 24 ساعته و همیشگی خدمات مشتریان ایران هتل آنلاین سفری راحت را برای شما رقم خواهد زد و امکان پیگیری رزرو را در هر ساعت از شبانه روز و هر مرحله از سفر فراهم می‌آورد.',
    },
    {
      question: getHomeSlot(headings, 'faqQuestion2').text,
      answer:
        'خیر، الزامی برای ثبت نام وجود ندارد اما با ثبت نام می‌توانید به تاریخچه رزروهای خود دسترسی داشته باشید.',
    },
    {
      question: getHomeSlot(headings, 'faqQuestion3').text,
      answer:
        'کد تخفیف را در مرحله نهایی پرداخت در کادر مربوطه وارد کرده و دکمه اعمال را بزنید تا مبلغ کسر شود.',
    },
    {
      question: getHomeSlot(headings, 'faqQuestion4').text,
      answer:
        'بله، امکان کنسلی طبق قوانین هتل وجود دارد. می‌توانید درخواست خود را در پنل کاربری ثبت کنید.',
    },
    {
      question: getHomeSlot(headings, 'faqQuestion5').text,
      answer:
        'پلتفرم ما تمامی شهرهای ایران و بیش از 1000 اقامتگاه فعال را پوشش می‌دهد.',
    },
  ];

  const sectionTitle = getHomeSlot(headings, 'faqTitle');

  return (
    <section className="faq-section">
      <div className="container">
        <SeoHeading slot={sectionTitle} className="faq-section-title" />

        <div className="accordion-box">
          {faqData.map((item, index) => {
            const isOpen = openIndex === index;

            return (
              <div
                key={index}
                className={`accordion-item ${isOpen ? 'open' : 'closed'}`}
                onClick={() => toggleAccordion(index)}
              >
                <div className="accordion-header">
                  <div className="right-content">
                    <div className="icon-wrapper">
                      <img
                        src="/icons/quest.png"
                        alt="آیکون سوال"
                        className={`custom-icon ${isOpen ? 'active-icon' : 'inactive-icon'}`}
                      />
                    </div>

                    <h3 className={`question-text ${isOpen ? 'text-active' : ''}`}>
                      {item.question}
                    </h3>
                  </div>

                  <div className={`toggle-btn ${isOpen ? 'btn-active' : 'btn-inactive'}`}>
                    {isOpen ? (
                      <ChevronUp size={20} strokeWidth={3} color="#fff" />
                    ) : (
                      <ChevronDown size={20} strokeWidth={3} color="#6b7280" />
                    )}
                  </div>
                </div>

                <div className={`accordion-body ${isOpen ? 'show' : ''}`}>
                  <div className="answer-content">
                    <p className="answer-text">{item.answer}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <style jsx>{`
        .faq-section {
          width: 100%;
          padding: 10px 20px;
          direction: rtl;
          font-family: inherit;
          position: relative;
          z-index: 1;
        }

        .container {
          max-width: 1250px;
          margin: 0 auto;
        }

        :global(.faq-section-title) {
          text-align: right;
          font-size: 26px;
          font-weight: 800;
          color: #333;
          margin: 0 0 30px 0;
          display: block;
        }

        .accordion-box {
          border: 1px solid #d1d5db;
          border-radius: 12px;
          overflow: hidden;
          background-color: none;
        }

        .accordion-item {
          border-bottom: 1px solid #e5e7eb;
          cursor: pointer;
          transition: background-color 0.3s ease;
        }

        .accordion-item:last-child {
          border-bottom: none;
        }

        .accordion-item.closed {
          background-color: #f3f4f6;
        }

        .accordion-item.closed:hover {
          background-color: #e5e7eb;
        }

        .accordion-item.open {
          background-color: #ffffff;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
          z-index: 10;
          position: relative;
        }

        .accordion-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 18px 24px;
          min-height: 75px;
        }

        .right-content {
          display: flex;
          align-items: center;
          gap: 15px;
          flex: 1;
        }

        .custom-icon {
          width: 24px;
          height: 24px;
          display: block;
          transition: filter 0.3s ease;
        }

        .inactive-icon {
          filter: grayscale(100%) opacity(0.6);
        }

        .active-icon {
          filter: none;
        }

        .question-text {
          font-size: 15px;
          font-weight: 700;
          color: #4b5563;
          margin: 0;
          transition: color 0.3s;
        }

        .text-active {
          color: #1f2937;
        }

        .toggle-btn {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          margin-right: 15px;
          transition: all 0.3s ease;
        }

        .btn-active {
          background-color: #75a626;
          box-shadow: 0 2px 8px rgba(117, 166, 38, 0.4);
        }

        .btn-inactive {
          background-color: #dde3ea;
        }

        .accordion-body {
          display: grid;
          grid-template-rows: 0fr;
          transition: grid-template-rows 0.4s ease-out;
        }

        .accordion-body.show {
          grid-template-rows: 1fr;
        }

        .answer-content {
          overflow: hidden;
        }

        .answer-text {
          font-size: 13px;
          line-height: 2.4;
          color: #555;
          text-align: justify;
          margin: 0;
          padding: 0 65px 30px 24px;
          border-top: 1px solid transparent;
        }

        @media (max-width: 768px) {
          :global(.faq-section-title) {
            text-align: center;
            font-size: 22px;
            margin-bottom: 20px;
          }

          .accordion-header {
            padding: 15px;
          }

          .question-text {
            font-size: 13px;
          }

          .answer-text {
            padding: 0 15px 20px 15px;
            font-size: 12px;
          }

          .toggle-btn {
            width: 28px;
            height: 28px;
          }

          .custom-icon {
            width: 20px;
            height: 20px;
          }
        }
      `}</style>
    </section>
  );
};

export default FAQSection;